import React from 'react';
import { motion } from 'framer-motion';
export function HeroBanner() {
  return <section className="relative h-[460px] md:h-[540px] overflow-hidden bg-charcoal" data-id="element-552">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0" data-id="element-553">
        <img src="https://cdn.magicpatterns.com/uploads/gjErCzuPq7KPAVy3xAtHNB/Shane_merem_Create_a_beautiful_high-end_hero_image_for_a_handmade_decorative_9acc35cd-2a94-40a8-8946-ba0d7b2e5dda.png" alt="Elegant home interior featuring decorative switch plates" className="w-full h-full object-cover object-center opacity-50" data-id="element-554" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/80 to-charcoal/40" data-id="element-555"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center" data-id="element-556">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl" data-id="element-557">
          <span className="inline-block py-1.5 px-4 rounded-sm bg-gold/20 text-gold-light border border-gold/30 text-xs font-bold tracking-[0.2em] uppercase mb-5" data-id="element-558">
            Handmade in the USA
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white leading-tight mb-4" data-id="element-559">
            Decorative Light Switch Plates &amp; Outlet Covers for Nearly Every
            Style
          </h2>

          <p className="text-lg md:text-xl text-gold-light mb-4 font-serif" data-id="element-560">
            Handmade switchplates with matching screws, available in hundreds of
            designs and nearly every size.
          </p>

          <p className="text-base md:text-lg text-cream/90 mb-8 font-light leading-relaxed" data-id="element-561">
            Shop decorative switch plates and outlet covers for coastal, floral,
            farmhouse, beach, vintage, holiday, and more. A small detail that
            adds real personality to your home.
          </p>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-562">
            <a href="#/switchplates" className="inline-flex justify-center items-center px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors shadow-lg text-sm uppercase tracking-wider" data-id="element-563">
              Shop Categories
            </a>
            <a href="#/custom-orders" className="inline-flex justify-center items-center px-8 py-3.5 bg-white/10 border border-white/40 text-white hover:bg-white hover:text-charcoal font-bold rounded-sm transition-colors text-sm uppercase tracking-wider backdrop-blur-sm" data-id="element-564">
              Custom Orders
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}